(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("window"));
	else if(typeof define === 'function' && define.amd)
		define(["window"], factory);
	else if(typeof exports === 'object')
		exports["NiceSelect"] = factory(require("window"));
	else
		root["NiceSelect"] = factory(root["window"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 